<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import TableLoading from "@/components/ipos/table-loading";
import TableEmpty from "@/components/ipos/table-empty";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import UtilsMixin from "@/mixins/utils";
import {accountantService} from "@/services/authservice/accountant";
import {accountService} from "@/services/authservice/account";
import {commonService} from "@/services/common";
import PrintDetailCollectPay2 from "@/components/ipos/print-detail-collect-pay-2";

export default {
  page: {
    title: "Danh sách chứng từ thanh toán của Shipper",
    meta: [{name: "description", content: appConfig.description}],
  },
  mixins: [UtilsMixin],
  components: {Layout, PageHeader, TableLoading, TableEmpty, DatePicker, Multiselect, PrintDetailCollectPay2},
  data() {
    return {
      listData: [],
      listRegion: [],
      title: "Danh sách chứng từ thanh toán của Shipper",
      items: [
        {
          text: "Trang chủ",
          href: "/",
        },
        {
          text: "Công nợ giao hàng",
          active: true,
        },
        {
          text: "Chứng từ thanh toán",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "value",
      sortDesc: false,
      fields: [
        {key: "index", label: "#"},
        {key: "payment_id", label: "Mã phiếu"},
        {key: "total_amount", label: "Tiền thanh toán"},
        {key: "payer_name", label: "Người thanh toán"},
        {key: "status", label: "Trạng thái"},
        {key: "note", label: "Ghi chú"},
        {key: "created_by", label: "Người khởi tạo"},
        {key: "created_at", label: "Ngày khởi tạo"},
      ],
      isBusy: false,
      me: {},
      listStatus: [
        {id: "COMPLETED", name: "Hoàn thành"},
        {id: "CANCELED", name: "Đã huỷ"},
      ],
      type: "shipper",
      listShipper: [],
      searchData: {
        date: [],
        status: {id: "COMPLETED", name: "Hoàn thành"},
        shipper: "",
      },
      totalAmount: 0,
      totalCollect: 0,
      totalPay: 0,
      dataPrint: {},
      distributorInfo: {},
    };
  },
  beforeMount() {
    this.me = JSON.parse(localStorage.getItem("user"));
    this.getStartEndMonth();
    this.getInitData();
  },
  computed: {
    rows() {
      return this.listData.length;
    },
  },
  mounted() {
    this.totalRows = this.listData.length;
  },
  methods: {
    onFiltered() {
      this.totalRows = this.listData.length;
      this.currentPage = 1;
    },

    async getStartEndMonth() {
      let date = new Date();
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.searchData.date = [firstDay, lastDay];
      const resDistributor = await commonService.getDistributorInfo({uid: this.me.distributor_uid});
      this.distributorInfo = resDistributor.data.data;
    },

    async getInitData() {
      this.isBusy = true;
      // get list shipper
      const resShipper = await accountService.getList({role_id: 'SHIPPER'});
      if (resShipper.data.error) {
        this.listShipper = [];
      } else {
        this.listShipper = resShipper.data.data;
      }
      await this.getListPaid();
      this.isBusy = false;
    },

    async getListPaid() {
      let start = "";
      let end = "";
      if (this.searchData.date.length > 0 && this.searchData.date[0] && this.searchData.date[1]) {
        start = this.searchData.date[0].setHours(0, 0, 0, 0);
        end = this.searchData.date[1].setHours(23, 59, 59, 999);
      } else {
        let date = new Date();
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        this.searchData.date = [firstDay, lastDay];
        start = firstDay.setHours(0, 0, 0, 0);
        end = lastDay.setHours(23, 59, 59, 999);
      }
      let param = {
        results_per_page: 1000,
        status: this.searchData.status ? this.searchData.status.id : "",
        from_timestamp: start,
        to_timestamp: end,
        extra_type: "SHIPPER",
        payer_id: this.searchData.shipper ? this.searchData.shipper.email : "",
      }
      const response = await accountantService.billPaid(this.type, param);
      if (response.data.error) {
        this.listData = {};
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra",
          text: response.data.error.message,
        });
      } else {
        this.listData = response.data.data;
        this.totalAmount = 0;
        this.totalCollect = 0;
        this.totalPay = 0;
        this.listData.forEach(e => {
          this.totalAmount = this.totalAmount + e.total_amount;
          if (e.total_amount > 0) {
            this.totalCollect = this.totalCollect + e.total_amount;
          } else {
            this.totalPay = this.totalPay + e.total_amount;
          }
        });
      }
    },

    async onSearch() {
      this.isBusy = true;
      await this.getListPaid();
      this.isBusy = false;
    },

    async onResetSearch() {
      this.isBusy = true;
      this.currentPage = 1;
      this.searchData = {
        shipper: "",
        date: [],
        status: {id: "COMPLETED", name: "Hoàn thành"},
      }
      await this.getListPaid();
      this.isBusy = false;
    },

    onPrint() {
      this.dataPrint = {
        fromDate: this.searchData.date[0],
        toDate: this.searchData.date[1],
        totalAmount: this.totalAmount,
        totalCollect: this.totalCollect,
        totalPay: this.totalPay,
        details: this.listData,
      };
      setTimeout(() => {
        this.$htmlToPaper('printReportInventory', this.localLandScapeOptions, async () => {
        });
      }, 1000);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-12">
            <div class="d-flex search-container mb-3">
              <multiselect
                  id="shipInfo"
                  v-model="searchData.shipper"
                  :options="listShipper"
                  track-by="id"
                  label="name"
                  placeholder="Chọn giao hàng"
                  noOptions="Danh sách trống"
                  :show-labels="false"
                  class="mr-2"
              ></multiselect>
              <multiselect
                  id="gender"
                  v-model="searchData.status"
                  :options="listStatus"
                  track-by="id"
                  label="name"
                  :searchable="false"
                  placeholder="Chọn trạng thái"
                  noOptions="Danh sách trống"
                  :show-labels="false"
                  class="mr-2"
              ></multiselect>
              <date-picker
                  :shortcuts="shortcuts"
                  v-model="searchData.date"
                  :first-day-of-week="1"
                  lang="en"
                  range
                  format="DD/MM/YYYY"
                  placeholder="Chọn khoảng thời gian"
              ></date-picker>
              <div class="ml-3">
                <button type="button" class="btn btn-primary" @click="onSearch">Lọc</button>
                <button type="button" class="ml-2 btn btn-secondary" @click="onResetSearch">
                  <i class="bx bx-revision"></i>
                </button>
              </div>
              <button
                  type="button"
                  @click="onPrint"
                  class="ml-auto btn btn-light">
                <i class="bx bx-printer font-size-16 align-middle mr-2"></i> In
              </button>
            </div>
          </div>
        </div>
        <div class="alert alert-info">
          Tổng tiền: {{ formatPrice(totalAmount,true) }}
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Hiện
                    <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;mục
                  </label>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  show-empty
                  :items="listData"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  :busy="isBusy"
                  table-class="scroll-table"
              >
                <template v-slot:table-busy>
                  <TableLoading/>
                </template>
                <template v-slot:empty>
                  <TableEmpty/>
                </template>
                <template v-slot:cell(index)="row">
                  {{ ((currentPage - 1) * perPage) + row.index + 1 }}
                </template>
                <template v-slot:cell(payment_id)="row">
                  <router-link :to="{ name: 'PaidDetail', params: { id: row.item.id }}">
                    {{ row.item.payment_id }}
                  </router-link>
                </template>
                <template v-slot:cell(status)="row">
                  <span class="badge badge-pill p-2 text-uppercase"
                        :class="renderStatus(row.item.status)[1]">
                    {{ renderStatus(row.item.status)[0] }}
                  </span>
                </template>
                <template v-slot:cell(total_amount)="row">
                  {{ formatPrice(row.item.total_amount) }}
                </template>
                <template v-slot:cell(created_at)="row">
                  {{ formatDateUnix(row.item.created_at) }}
                </template>
                <template v-slot:cell(note)="row" style="max-width: 150px">
                  <span>{{__formatShowNote(row.item.note)}}</span>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="mt-3 float-right">
                  <b-pagination
                      class="mb-0"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <div id="printReportInventory" class="bg-white p-3 text-dark d-none" v-if="!isBusy">
      <PrintDetailCollectPay2 :data="dataPrint" :distributor="distributorInfo" :me="me"/>
    </div>
  </Layout>
</template>